import SERVICE_URL from "../config/API_DATA"
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';
import FILE_NAME from "../config/API_DATA";
export default class CreateAgent {
    static buildRequest(pAgentRegObj,pCapText) {
        let returnValue = null;
        if (BaseConfiguration.isDebug) console.log(JSON.stringify(pAgentRegObj));
        try {
            let body = {
                agent: {
                    mobile_number: pAgentRegObj.contDet.mblNo,
                    mobile_code: pAgentRegObj.contDet.selCountryObj.calling_code,
                    emailid: pAgentRegObj.contDet.email,
                    contact_postalcode: pAgentRegObj.contDet.postCode,
                    contactCountrycode: pAgentRegObj.contDet.selMobileCodeObj.countrycode,
                    contact_state: pAgentRegObj.contDet.state.statecode,
                    contact_city: pAgentRegObj.contDet.city,
                    contact_address: pAgentRegObj.contDet.address,
                    contact_name: pAgentRegObj.contDet.name,
                    agencyname: pAgentRegObj.comDet.agencyName,
                    iatanumber: pAgentRegObj.comDet.IATANumber,
                    business_regno: pAgentRegObj.comDet.buisnessRegNo,
                    org: pAgentRegObj.contDet.org
                },
                user: {
                    emailid: pAgentRegObj.logDet.logMail,
                    password: pAgentRegObj.logDet.logPwd,
                    enteredcaptcha: pAgentRegObj.logDet.captcha,
                    captchaText: pCapText
                }
            }
            returnValue = body;
        }
        catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_CREATE_AGENT, "error in building body for CreateAgent api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.CREATE_AGENT, pReqOptions);
        }
        catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_CREATE_AGENT, "error in getting Response from  CreateAgent api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        if (BaseConfiguration.isDebug) console.log(returnValue);
        return returnValue;
        
    }
}